<ion-chip *ngIf="!tags.length; else tagTemplate" [disabled]="true"> No tag to display</ion-chip>
<ng-template #tagTemplate>
  <div style="margin-bottom: 12px">
    <div *ngFor="let tag of tags | slice: 0:10" class="chip">{{ tag }}</div>
  </div>
  <span *ngIf="tags.length > 10" id="open-modal-{{ tags.toString() }}" expand="block" class="show-more">Show all</span>
  <ion-modal #modal trigger="open-modal-{{ tags.toString() }}" [canDismiss]="true">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ title }}</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="modal.dismiss()">Close</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <div *ngFor="let tag of tags" class="chip">{{ tag }}</div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ng-template>
